import { ConnectedPlumaProvider } from '@/components/connected-pluma-provider';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useInjectImportShim } from '../hooks/use-inject-import-shim';
import { useLoadShims } from '../hooks/use-load-shims';
import { PageLoader } from '@customerio/pluma-components/react';

export default function EmbedRoot() {
  const loaded = useLoadShims();

  return <ConnectedPlumaProvider>{loaded ? <EmbedApp /> : null}</ConnectedPlumaProvider>;
}

function EmbedApp() {
  const isLoaded = useInjectImportShim();

  /**
   * Copy the parent window's Hydra account dc to the child window.
   * This is needed so the embed editors can differentiate between
   * EU and US data centers.
   */
  useEffect(function copyParentDC() {
    // Safely crash if not possible to access parent window
    try {
      // If we are in an iframe, copy the parent window's dc
      if (window !== window.top) {
        Object.assign(window, {
          __hydra__: {
            account: {
              dc: window.parent?.__hydra__?.account?.dc ?? 'us',
            },
          },
        });
      }
    } catch {
      // Do nothing
    }
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        backgroundColor: 'var(--pluma-palette-grey-050)',
      }}
    >
      {isLoaded ? <Outlet /> : <PageLoader />}
    </div>
  );
}
